import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { TypographyLarge, TypographySmall } from "@/components/ui/typography";
import type { GetAllBankAccountsBankAccount } from "@/queries/bank-accounts/get-all";
import { useTranslation } from "react-i18next";
import AccountCard from "./bank-account-card";

export const ManualBankAccountsSection = ({
  onSetJournalAccount,
  bankAccounts,
}: {
  onSetJournalAccount?: (journalAccountId: string) => Promise<void>;
  bankAccounts: GetAllBankAccountsBankAccount[];
}) => {
  const { t } = useTranslation();

  const bankAccountsWithoutConnection = bankAccounts.filter(
    (bankAccount) =>
      !bankAccount.bankConnection && !bankAccount.finapiAccountId,
  );

  if (bankAccountsWithoutConnection.length === 0) {
    return null;
  }

  return (
    <Card className="mt-4">
      <CardHeader>
        <div className="space-y-2">
          <TypographyLarge>
            {t("bank_settings.manual_bank_accounts.title")}
          </TypographyLarge>
          <TypographySmall className="text-muted-foreground">
            {t("bank_settings.manual_bank_accounts.description")}
          </TypographySmall>
        </div>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        {bankAccountsWithoutConnection?.map((bankAccount) => (
          <AccountCard
            key={bankAccount.bankAccountId}
            account={bankAccount}
            onSetJournalAccount={onSetJournalAccount}
          />
        ))}
      </CardContent>
    </Card>
  );
};
